import { Select, SelectContent, SelectTrigger, SelectValue, SelectItem } from 'shared/ui/select';
import { FormControl, FormField, FormMessage } from 'shared/ui/form';
import type { Control, FieldValues, Path } from 'react-hook-form';
import * as React from 'react';
import type { SelectProps } from '@radix-ui/react-select';
import { useCallback } from 'react';
import { Label } from 'shared/ui/label';
import { Skeleton } from 'shared/ui/skeleton';
interface ISelectType {
  name: string;
  value: string;
}
interface FormControlSelectProps<TData extends FieldValues> extends SelectProps {
  name: Path<TData>;
  control: Control<TData> | undefined;
  items: ISelectType[];
  label?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  isLoading?: boolean;
}
export const FormControlSelect = <TData extends FieldValues,>({
  name,
  control,
  label,
  placeholder,
  items,
  onChange,
  isLoading,
  ...props
}: FormControlSelectProps<TData>) => {
  const handleChange = useCallback(<T extends string,>(value: T, formOnChange: (event: T) => void) => {
    if (!value) return;
    if (onChange) onChange(value);
    formOnChange(value);
  }, [onChange]);
  return <FormField name={name} control={control} render={({
    field
  }) => <div className="grid items-center gap-1 flex-1">
          {label && <Label className="text-title5">{label}</Label>}
          {isLoading ? <Skeleton className="h-[38px] w-full" variant="dark" /> : <Select onValueChange={(value: string) => handleChange(value, field.onChange)} value={field.value} {...props}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={placeholder ?? ''} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {items.map(({
          name,
          value
        }) => <SelectItem key={value} value={value}>
                    {name}
                  </SelectItem>)}
              </SelectContent>
            </Select>}
          <FormMessage />
        </div>} data-sentry-element="FormField" data-sentry-component="FormControlSelect" data-sentry-source-file="form-control-select.tsx" />;
};